import type { MarketVariants } from '@/lib/i18n'

export type Slide8TellSomeoneCopy = {
  eyebrow: string
  title: string
  body1: string
}

export const copy: MarketVariants<Slide8TellSomeoneCopy> = {
  US: {
    eyebrow: 'Step six',
    title: 'Tell someone you trust.',
    body1:
      'A family member, a close friend, or someone you trust. Talking about what happened helps you process it, and helps the people around you spot the same thing if it ever comes their way.',
  },
  ar: {
    eyebrow: 'الخطوة السادسة',
    title: 'أخبر شخصاً تثق به.',
    body1:
      'أحد أفراد العائلة، أو صديق مقرّب، أو أي شخص تثق به. الحديث عمّا حدث يساعدك على تجاوزه، ويساعد من حولك على اكتشاف الأمر نفسه إذا واجههم يوماً.',
  },
}
